import React, { useState, useEffect } from 'react';
import { Form, Button, Row, Col, Spinner, Card } from 'react-bootstrap';
import { useQuery } from 'react-query';
import { toast } from 'react-toastify';
import { Get, Post, Put } from '../../../../utils/httpProvider';
import { TAILIEUKHAC_API, BaseGatewayImage } from '../../../../utils/apiUrl';
import { thoiGianDanhGiaValue } from '../../../../utils/define';
import DocumentInput from '../../../../components/document-input/DocumentInput';
import moment from 'moment';

const FieldDisplayFile = ({ label, value }) => {
    const getSafeUrl = (path) => {
        if (!path) return null;
        if (path.startsWith('http')) return path;
        const baseUrl = BaseGatewayImage.endsWith('/') ? BaseGatewayImage.slice(0, -1) : BaseGatewayImage;
        const safePath = path.startsWith('/') ? path : `/${path}`;
        return `${baseUrl}${safePath}`;
    };

    let files = [];
    if (value) {
        try {
            const parsed = JSON.parse(value);
            if (Array.isArray(parsed)) {
                files = parsed;
            } else {
                files = [{ filePath: value, name: value.split('/').pop() }];
            }
        } catch (e) {
            files = [{ filePath: value, name: value.split('/').pop() }];
        }
    }

    return (
        <Form.Group className="mb-3">
            {label && <Form.Label className="font-weight-bold">{label}</Form.Label>}
            <div className="d-flex flex-wrap">
                {files.length > 0 ? (
                    files.map((file, idx) => {
                        const path = file.filePath || file;
                        let name = file.name || (typeof path === 'string' ? path.split('/').pop() : 'File');
                        name = name.replace(/_\d{14}(?=\.\w+$|$)/, '');
                        return (
                            <a key={idx} href={getSafeUrl(path)} target="_blank" rel="noreferrer" className={`btn btn-outline-primary text-left ${label ? '' : 'btn-sm'} mb-1 mr-1`} style={{ maxWidth: '100%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'inline-block' }} title={name}>
                                <i className="fas fa-paperclip mr-1"></i> {name}
                            </a>
                        );
                    })
                ) : (
                    <span className="text-muted small">Không có file</span>
                )}
            </div>
        </Form.Group>
    );
};

const FieldDisplay = ({ label, value }) => {
    return (
        <Form.Group className="mb-3">
            {label && <Form.Label className="font-weight-bold">{label}</Form.Label>}
            <div>
                <span className="text-dark" style={{ fontSize: '15px', fontWeight: 600 }}>
                    {value !== null && value !== undefined && value !== '' ? value : <span className="text-muted font-italic" style={{ fontWeight: 'normal' }}>Chưa cập nhật</span>}
                </span>
            </div>
        </Form.Group>
    );
};

const TaiLieuKhacForm = ({ baoVeCapVienId, readOnly = false, isUserView = false, onDataLoaded, onSaveSuccess }) => {
    const [saving, setSaving] = useState(false);
    
    const [taiLieuKhacId, setTaiLieuKhacId] = useState(null);
    const [isPhieuDanhGia, setIsPhieuDanhGia] = useState(true);
    const [isBienBanKiemPhieu, setIsBienBanKiemPhieu] = useState(true);
    const [fileMinhChungBBKP, setFileMinhChungBBKP] = useState('');
    const [isCoChuKy, setIsCoChuKy] = useState(true);
    const [fileMinhChungCCk, setFileMinhChungCCk] = useState('');
    const [isBanNhanXet, setIsBanNhanXet] = useState(true);
    const [ngayNhanXet, setNgayNhanXet] = useState('');
    const [lucDanhGia, setLucDanhGia] = useState(thoiGianDanhGiaValue.truoc);
    const [isBanSaoGiay, setIsBanSaoGiay] = useState(true);
    const [ngayBanSaoGiay, setNgayBanSaoGiay] = useState('');
    const [isVanBanBaoCao, setIsVanBanBaoCao] = useState(true);
    const [fileMinhChungVBBC, setFileMinhChungVBBC] = useState('');
    const [isYKienThieuSot, setIsYKienThieuSot] = useState(true);

    const { data: queryRes, refetch, isLoading } = useQuery(
        ['taiLieuKhacData', baoVeCapVienId], 
        () => Get(`${TAILIEUKHAC_API.GET_BY_BAOVECAPVIEN_ID}/${baoVeCapVienId}`),
        { 
            enabled: !!baoVeCapVienId,
            refetchOnWindowFocus: false 
        }
    );

    useEffect(() => {
        if (queryRes) {
            let item = null;
            if (Array.isArray(queryRes)) {
                item = queryRes[0];
            } else if (queryRes.data && Array.isArray(queryRes.data)) {
                item = queryRes.data[0];
            } else if (queryRes.data?.$values) {
                item = queryRes.data.$values[0];
            } else if (queryRes.data) {
                item = queryRes.data;
            } else {
                item = queryRes;
            }

            if (item && item.id) {
                setTaiLieuKhacId(item.id);
                setIsPhieuDanhGia(item.isPhieuDanhGia !== false);
                setIsBienBanKiemPhieu(item.isBienBanKiemPhieu !== false);
                setFileMinhChungBBKP(item.fileMinhChungBBKP || '');
                setIsCoChuKy(item.isCoChuKy !== false);
                setFileMinhChungCCk(item.fileMinhChungCCk || '');
                setIsBanNhanXet(item.isBanNhanXet !== false);
                setNgayNhanXet(item.ngayNhanXet ? moment(item.ngayNhanXet).format('YYYY-MM-DD') : '');
                setLucDanhGia(item.lucDanhGia || thoiGianDanhGiaValue.truoc);
                setIsBanSaoGiay(item.isBanSaoGiay !== false);
                setNgayBanSaoGiay(item.ngayBanSaoGiay ? moment(item.ngayBanSaoGiay).format('YYYY-MM-DD') : '');
                setIsVanBanBaoCao(item.isVanBanBaoCao !== false);
                setFileMinhChungVBBC(item.fileMinhChungVBBC || '');
                setIsYKienThieuSot(item.isYKienThieuSot !== false);
                
                if (onDataLoaded) onDataLoaded(true);
            } else {
                if (onDataLoaded) onDataLoaded(false);
            }
        } else if (queryRes === null) {
            if (onDataLoaded) onDataLoaded(false);
        }
    }, [queryRes]);

    const handleSave = async () => {
        setSaving(true);
        try {
            const payload = {
                BaoVeCapVienId: baoVeCapVienId,
                IsPhieuDanhGia: isPhieuDanhGia,
                IsBienBanKiemPhieu: isBienBanKiemPhieu,
                FileMinhChungBBKP: fileMinhChungBBKP || '',
                IsCoChuKy: isCoChuKy,
                FileMinhChungCCk: fileMinhChungCCk || '',
                IsBanNhanXet: isBanNhanXet,
                NgayNhanXet: ngayNhanXet || null,
                LucDanhGia: lucDanhGia,
                IsBanSaoGiay: isBanSaoGiay,
                NgayBanSaoGiay: ngayBanSaoGiay || null,
                IsVanBanBaoCao: isVanBanBaoCao,
                FileMinhChungVBBC: fileMinhChungVBBC || '',
                IsYKienThieuSot: isYKienThieuSot
            };

            if (taiLieuKhacId) {
                await Put(TAILIEUKHAC_API.UPDATE_ITEM, taiLieuKhacId, { ...payload, Id: taiLieuKhacId });
            } else {
                await Post(TAILIEUKHAC_API.CREATE, null, payload);
            }

            toast.success('Lưu thông tin thành công!');
            await refetch();
            if (onSaveSuccess) onSaveSuccess();
        } catch (error) {
            console.error(error);
            toast.error('Có lỗi xảy ra khi lưu thông tin.');
        } finally {
            setSaving(false);
        }
    };

    if (isLoading) return <div className="text-center p-3"><Spinner animation="border" variant="primary" /></div>;

    return (
        <div className="bg-white p-3 rounded">
            <Card className="mb-3 border-info shadow-sm">
                <Card.Header className="bg-info text-white font-weight-bold">Hồ sơ tài liệu khác</Card.Header>
                <Card.Body>
                    <Row>
                        <Col md={12} className="mb-3">
                            {readOnly || isUserView ? (
                                <FieldDisplay label={<><span className="text-danger">1.</span> Phiếu đánh giá của Hội đồng</>} value={isPhieuDanhGia ? 'Có' : 'Không'} />
                            ) : (
                                <Form.Group>
                                    <Form.Label className="font-weight-bold"><span className="text-danger">1.</span> Phiếu đánh giá của Hội đồng </Form.Label>
                                    <div>
                                        <Form.Check 
                                            inline
                                            type="radio"
                                            label="Có"
                                            name="isPhieuDanhGia"
                                            checked={isPhieuDanhGia === true}
                                            onChange={() => setIsPhieuDanhGia(true)}
                                        />
                                        <Form.Check 
                                            inline
                                            type="radio"
                                            label="Không"
                                            name="isPhieuDanhGia"
                                            checked={isPhieuDanhGia === false}
                                            onChange={() => setIsPhieuDanhGia(false)}
                                        />
                                    </div>
                                </Form.Group>
                            )}
                        </Col>

                        <Col md={12} className="mb-3">
                            {readOnly || isUserView ? (
                                <FieldDisplay label={<><span className="text-danger">2.</span> Biên bản kiểm phiếu</>} value={isBienBanKiemPhieu ? 'Có' : 'Không'} />
                            ) : (
                                <Form.Group>
                                    <Form.Label className="font-weight-bold"><span className="text-danger">2.</span> Biên bản kiểm phiếu</Form.Label>
                                    <div>
                                        <Form.Check 
                                            inline
                                            type="radio"
                                            label="Có"
                                            name="isBienBanKiemPhieu"
                                            checked={isBienBanKiemPhieu === true}
                                            onChange={() => setIsBienBanKiemPhieu(true)}
                                        />
                                        <Form.Check 
                                            inline
                                            type="radio"
                                            label="Không"
                                            name="isBienBanKiemPhieu"
                                            checked={isBienBanKiemPhieu === false}
                                            onChange={() => setIsBienBanKiemPhieu(false)}
                                        />
                                    </div>
                                </Form.Group>
                            )}
                        </Col>
                        
                        {isBienBanKiemPhieu && (
                            <Col md={12} className="mb-3">
                                {readOnly || isUserView ? (
                                    <FieldDisplayFile label={<>File minh chứng biên bản kiểm phiếu</>} value={fileMinhChungBBKP} />
                                ) : (
                                    <Form.Group>
                                        <DocumentInput
                                            labelTitle={<>File minh chứng biên bản kiểm phiếu</>}
                                            value={fileMinhChungBBKP}
                                            onChangeProp={(url) => setFileMinhChungBBKP(url)}
                                        />
                                    </Form.Group>
                                )}
                            </Col>
                        )}

                        <Col md={12} className="mb-3">
                            {readOnly || isUserView ? (
                                <FieldDisplay label={<><span className="text-danger">3.</span> Danh sách Hội đồng có chữ ký của các thành viên có mặt</>} value={isCoChuKy ? 'Có' : 'Không'} />
                            ) : (
                                <Form.Group>
                                    <Form.Label className="font-weight-bold"><span className="text-danger">3.</span> Danh sách Hội đồng có chữ ký của các thành viên có mặt</Form.Label>
                                    <div>
                                        <Form.Check 
                                            inline
                                            type="radio"
                                            label="Có"
                                            name="isCoChuKy"
                                            checked={isCoChuKy === true}
                                            onChange={() => setIsCoChuKy(true)}
                                        />
                                        <Form.Check 
                                            inline
                                            type="radio"
                                            label="Không"
                                            name="isCoChuKy"
                                            checked={isCoChuKy === false}
                                            onChange={() => setIsCoChuKy(false)}
                                        />
                                    </div>
                                </Form.Group>
                            )}
                        </Col>

                        {isCoChuKy && (
                            <Col md={12} className="mb-3">
                                {readOnly || isUserView ? (
                                    <FieldDisplayFile label={<>File minh chứng</>} value={fileMinhChungCCk} />
                                ) : (
                                    <Form.Group>
                                        <DocumentInput
                                            labelTitle={<>File minh chứng</>}
                                            value={fileMinhChungCCk}
                                            onChangeProp={(url) => setFileMinhChungCCk(url)}
                                        />
                                    </Form.Group>
                                )}
                            </Col>
                        )}

                        <Col md={12} className="mb-3">
                            {readOnly || isUserView ? (
                                <FieldDisplay label={<><span className="text-danger">4.</span> Bản nhận xét, đánh giá và đề nghị cho NCS bảo vệ của CBHD</>} value={isBanNhanXet ? 'Có' : 'Không'} />
                            ) : (
                                <Form.Group>
                                    <Form.Label className="font-weight-bold"><span className="text-danger">4.</span> Bản nhận xét, đánh giá và đề nghị cho NCS bảo vệ của CBHD</Form.Label>
                                    <div>
                                        <Form.Check 
                                            inline
                                            type="radio"
                                            label="Có"
                                            name="isBanNhanXet"
                                            checked={isBanNhanXet === true}
                                            onChange={() => setIsBanNhanXet(true)}
                                        />
                                        <Form.Check 
                                            inline
                                            type="radio"
                                            label="Không"
                                            name="isBanNhanXet"
                                            checked={isBanNhanXet === false}
                                            onChange={() => setIsBanNhanXet(false)}
                                        />
                                    </div>
                                </Form.Group>
                            )}
                        </Col>

                        {isBanNhanXet && (
                            <>
                                <Col md={6} className="mb-3">
                                    {readOnly || isUserView ? (
                                        <FieldDisplay label="Ngày nhận xét" value={ngayNhanXet ? moment(ngayNhanXet).format('DD/MM/YYYY') : ''} />
                                    ) : (
                                        <Form.Group>
                                            <Form.Label className="font-weight-bold">Ngày nhận xét</Form.Label>
                                            <Form.Control
                                                type="date"
                                                value={ngayNhanXet}
                                                onChange={(e) => setNgayNhanXet(e.target.value)}
                                            />
                                        </Form.Group>
                                    )}
                                </Col>
                                
                                <Col md={6} className="mb-3">
                                    {readOnly || isUserView ? (
                                        <FieldDisplay label="Thời gian nhận xét" value={lucDanhGia === thoiGianDanhGiaValue.truoc ? 'Trước khi bảo vệ' : 'Sau khi bảo vệ'} />
                                    ) : (
                                        <Form.Group>
                                            <Form.Label className="font-weight-bold">Thời gian nhận xét</Form.Label>
                                            <div>
                                                <Form.Check 
                                                    inline
                                                    type="radio"
                                                    label="Trước khi bảo vệ"
                                                    name="lucDanhGia"
                                                    checked={lucDanhGia === thoiGianDanhGiaValue.truoc}
                                                    onChange={() => setLucDanhGia(thoiGianDanhGiaValue.truoc)}
                                                />
                                                <Form.Check 
                                                    inline
                                                    type="radio"
                                                    label="Sau khi bảo vệ"
                                                    name="lucDanhGia"
                                                    checked={lucDanhGia === thoiGianDanhGiaValue.sau}
                                                    onChange={() => setLucDanhGia(thoiGianDanhGiaValue.sau)}
                                                />
                                            </div>
                                        </Form.Group>
                                    )}
                                </Col>
                            </>
                        )}

                        <Col md={12} className="mb-3">
                            {readOnly || isUserView ? (
                                <FieldDisplay label={<><span className="text-danger">5.</span> Bản sao giấy biên nhận luận án của Thư viện Quốc gia Việt Nam</>} value={isBanSaoGiay ? 'Có' : 'Không'} />
                            ) : (
                                <Form.Group>
                                    <Form.Label className="font-weight-bold"><span className="text-danger">5.</span> Bản sao giấy biên nhận luận án của Thư viện Quốc gia Việt Nam</Form.Label>
                                    <div>
                                        <Form.Check 
                                            inline
                                            type="radio"
                                            label="Có"
                                            name="isBanSaoGiay"
                                            checked={isBanSaoGiay === true}
                                            onChange={() => setIsBanSaoGiay(true)}
                                        />
                                        <Form.Check 
                                            inline
                                            type="radio"
                                            label="Không"
                                            name="isBanSaoGiay"
                                            checked={isBanSaoGiay === false}
                                            onChange={() => setIsBanSaoGiay(false)}
                                        />
                                    </div>
                                </Form.Group>
                            )}
                        </Col>

                        {isBanSaoGiay && (
                            <Col md={6} className="mb-3">
                                {readOnly || isUserView ? (
                                    <FieldDisplay label="Ngày giấy biên nhận" value={ngayBanSaoGiay ? moment(ngayBanSaoGiay).format('DD/MM/YYYY') : ''} />
                                ) : (
                                    <Form.Group>
                                        <Form.Label className="font-weight-bold">Ngày giấy biên nhận</Form.Label>
                                        <Form.Control
                                            type="date"
                                            value={ngayBanSaoGiay}
                                            onChange={(e) => setNgayBanSaoGiay(e.target.value)}
                                        />
                                    </Form.Group>
                                )}
                            </Col>
                        )}

                        <Col md={12} className="mb-3">
                            {readOnly || isUserView ? (
                                <FieldDisplay label={<><span className="text-danger">6.</span> Văn bản báo cáo chi tiết của NCS về các điểm đã bổ sung, sửa chữa theo nghị quyết của Hội đồng, có xác nhận của CBHD, Chủ tịch HĐ</>} value={isVanBanBaoCao ? 'Có' : 'Không'} />
                            ) : (
                                <Form.Group>
                                    <Form.Label className="font-weight-bold"><span className="text-danger">6.</span> Văn bản báo cáo chi tiết của NCS về các điểm đã bổ sung, sửa chữa theo nghị quyết của Hội đồng, có xác nhận của CBHD, Chủ tịch HĐ</Form.Label>
                                    <div>
                                        <Form.Check 
                                            inline
                                            type="radio"
                                            label="Có"
                                            name="isVanBanBaoCao"
                                            checked={isVanBanBaoCao === true}
                                            onChange={() => setIsVanBanBaoCao(true)}
                                        />
                                        <Form.Check 
                                            inline
                                            type="radio"
                                            label="Không"
                                            name="isVanBanBaoCao"
                                            checked={isVanBanBaoCao === false}
                                            onChange={() => setIsVanBanBaoCao(false)}
                                        />
                                    </div>
                                </Form.Group>
                            )}
                        </Col>
                        
                        {isVanBanBaoCao && (
                            <Col md={12} className="mb-3">
                                {readOnly || isUserView ? (
                                    <FieldDisplayFile label={<>File minh chứng</>} value={fileMinhChungVBBC} />
                                ) : (
                                    <Form.Group>
                                        <DocumentInput
                                            labelTitle={<>File minh chứng</>}
                                            value={fileMinhChungVBBC}
                                            onChangeProp={(url) => setFileMinhChungVBBC(url)}
                                        />
                                    </Form.Group>
                                )}
                            </Col>
                        )}

                        <Col md={12} className="mb-3">
                            {readOnly || isUserView ? (
                                <FieldDisplay label={<><span className="text-danger">7.</span> Ý kiến về những thiếu sót về hình thức của luận án và tóm tắt của luận án</>} value={isYKienThieuSot ? 'Có' : 'Không'} />
                            ) : (
                                <Form.Group>
                                    <Form.Label className="font-weight-bold"><span className="text-danger">7.</span> Ý kiến về những thiếu sót về hình thức của luận án và tóm tắt của luận án</Form.Label>
                                    <div>
                                        <Form.Check 
                                            inline
                                            type="radio"
                                            label="Có"
                                            name="isYKienThieuSot"
                                            checked={isYKienThieuSot === true}
                                            onChange={() => setIsYKienThieuSot(true)}
                                        />
                                        <Form.Check 
                                            inline
                                            type="radio"
                                            label="Không"
                                            name="isYKienThieuSot"
                                            checked={isYKienThieuSot === false}
                                            onChange={() => setIsYKienThieuSot(false)}
                                        />
                                    </div>
                                </Form.Group>
                            )}
                        </Col>
                    </Row>
                </Card.Body>
            </Card>

            {!readOnly && !isUserView && (
                <div className="text-right mt-4">
                    <Button variant="success" onClick={() => handleSave()} disabled={saving}>
                        {saving ? <Spinner size="sm" animation="border" className="mr-1" /> : <i className="fas fa-save mr-1"></i>}
                        Lưu thông tin
                    </Button>
                </div>
            )}
        </div>
    );
};

export default TaiLieuKhacForm;
